export default "__VITE_ASSET__m4bD8vot__"